var ko = require('knockout'),
  $ = require('jquery'),
  APIHelper = require('_js/APIHelper'),
  RNStorage = require('_utils/storage'),
  FormDropdown = require('_components/atoms/form/form-dropdown/form-dropdown');

var STORAGE_KEY = 'courseOverviewList';

function CourseOverviewList(params) {
  var self = this;
  self.params = params;
  self.API = params.api;
  self.navigation = params.navigation;
}

CourseOverviewList.prototype.getSequencesLink = function(sequence) {
  var self = this;
  return self.getUrlSequencesBase() + '' + sequence.Url;
};

CourseOverviewList.prototype.init = function(element) {
  var self = this;
  self.$element = $(element);
  self.errorMessage = ko.observable();
  self.isLoading = ko.observable(false);

  self.isLoading.subscribe(function(isLoading) {
    $('.filter-option').prop('disabled', isLoading);
  });

  self.noSequencesFound = ko.observable(false);

  self.sequences = ko.observableArray().extend({ deferred: true });

  self.filterFromDate = ko
    .observable(self.getShortIsoDate(new Date()))
    .extend({ rateLimit: { method: 'notifyWhenChangesStop', timeout: 200 } });
  self.filterFromDate.subscribe(function() {
    self.checkDatesOrder();
  });
  self.filterToDate = ko
    .observable(self.getShortIsoDate(new Date()))
    .extend({ rateLimit: { method: 'notifyWhenChangesStop', timeout: 200 } });
  self.filterToDate.subscribe(function() {
    self.checkDatesOrder();
  });

  self.getSequences();

  self.numberOfSequences = ko.computed(function() {
    return self.sequences().length;
  });
  self.numberOfShowingSequences = ko.observable();

  self.sequencesFilterOptions = ko.observableArray();
  self.selectedFilterSequence = ko.observable();
  self.courseAdminOptions = ko.observableArray();
  self.selectedCourseAdmin = ko.observable();
  self.filteredSequences = ko.computed(self.filterSequences.bind(this));
  self.activeSort = self.listHeaders[0];

  var formDropdown = new FormDropdown();
  formDropdown.start(
    '.form-dropdown-open-button',
    '.quality-control-inspections'
  );
};

CourseOverviewList.prototype.createSubscribersForSelectedFilters = function() {
  this.selectedFilterSequence.subscribe(this.updateLocalStorage.bind(this));
};

CourseOverviewList.prototype.createSubscribersForSelectedCourseAdmin = function() {
  this.selectedCourseAdmin.subscribe(this.updateLocalStorage.bind(this));
};

CourseOverviewList.prototype.updateLocalStorage = function() {
  var filters = {
    filterSequence: this.selectedFilterSequence(),
    courseAdmin: this.selectedCourseAdmin()
  };
  RNStorage.storeItem(STORAGE_KEY, filters);
};

CourseOverviewList.prototype.applyStoredFilters = function() {
  var filters = JSON.parse(RNStorage.getItem(STORAGE_KEY));
  if (filters !== null && filters !== undefined) {
    this.selectedFilterSequence(filters.filterSequence);
    this.selectedCourseAdmin(filters.courseAdmin);
  }
};

CourseOverviewList.prototype.listHeaders = [
  {
    title: 'Kurstittel',
    sortKey: 'courseTitle',
    addClass: 'large-4',
    asc: true
  },
  { title: 'Kurs-ID', sortKey: '', addClass: 'large-1', asc: true },
  { title: 'Sekvens-ID', sortKey: '', addClass: 'large-1', asc: true },
  { title: 'Dato', sortKey: 'date', addClass: 'large-1', asc: true },
  { title: 'Sted', sortKey: 'city', addClass: 'large-2', asc: true },
  { title: 'Status', sortKey: '', addClass: 'large-3', asc: true }
];

CourseOverviewList.prototype.getShortIsoDate = function(newDate) {
  var today = new Date(newDate);

  var formatted =
    today.getFullYear() +
    '-' +
    ((today.getMonth() + 1).toString().length === 1
      ? '0' + (today.getMonth() + 1)
      : today.getMonth() + 1) +
    '-' +
    (today.getDate().toString().length === 1
      ? '0' + today.getDate()
      : today.getDate());

  return formatted;
};

CourseOverviewList.prototype.checkDatesOrder = function() {
  if (this.filterFromDate() > this.filterToDate()) {
    this.filterToDate(this.filterFromDate());
  }
};

CourseOverviewList.prototype.getApiFriendlyIsoDate = function(newDate) {
  var today = new Date(newDate);
  return (
    today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
  );
};

CourseOverviewList.prototype.getSequences = function() {
  var self = this;

  if (self.isLoading()) {
    return;
  }
  self.sequences([]);
  self.isLoading(true);
  self.noSequencesFound(false);
  var baseUrl = self.getUrlSequencesBase() + self.API.getSequences;

  baseUrl += '?fromDate=' + self.filterFromDate();
  baseUrl += '&toDate=' + self.filterToDate();

  APIHelper.get(
    baseUrl,
    function(data) {
      if (data.Result.length === 0) {
        self.noSequencesFound(true);
      } else {
        data.Result.forEach(function(sequence) {
          sequence.Sequence.Status = sequence.Status;
          if (sequence.Status === null) {
            sequence.Sequence.Status = [];
          }
          sequence.Sequence.CourseAdmin = sequence.CourseAdmin || '';
          sequence.Sequence.Url = sequence.Url;
          self.sequences.push(sequence.Sequence);
        });

        self.addOptions();
      }
      self.isLoading(false);
    },
    function(error) {
      self.errorMessage(
        error.responseJSON ? error.responseJSON.message : error
      );
      self.isLoading(false);
    }
  );
};

CourseOverviewList.prototype.getUrlSequencesBase = function() {
  return '';
};

CourseOverviewList.prototype.addOptions = function() {
  var self = this;
  self.sequencesFilterOptions.removeAll();

  self.sequencesFilterOptions.push('Alle');

  self.courseAdminOptions.removeAll();
  self.courseAdminOptions.push('Alle');

  self.sequences().forEach(function(sequence) {
    sequence.Status.forEach(function(status) {
      if (status !== '' && self.sequencesFilterOptions.indexOf(status) === -1) {
        self.sequencesFilterOptions.push(status);
      }
    });

    // Admin filter
    if (
      sequence.CourseAdmin !== '' &&
      self.courseAdminOptions().indexOf(sequence.CourseAdmin) < 0
    ) {
      self.courseAdminOptions.push(sequence.CourseAdmin);
    }
  });

  self.applyStoredFilters();
  self.createSubscribersForSelectedFilters();
  self.createSubscribersForSelectedCourseAdmin();
};

CourseOverviewList.prototype.filterSequences = function() {
  var self = this;
  var filteredList = self.sequences();

  var sequenceFilter = self.selectedFilterSequence();
  if (sequenceFilter && sequenceFilter !== self.sequencesFilterOptions()[0]) {
    filteredList = ko.utils.arrayFilter(filteredList, function(sequence) {
      var filter = '';
      sequence.Status.forEach(function(value) {
        if (value === sequenceFilter) {
          filter = value;
        }
      });
      return filter;
    });
  }

  var adminFilter = self.selectedCourseAdmin();
  if (adminFilter && adminFilter !== self.courseAdminOptions()[0]) {
    filteredList = ko.utils.arrayFilter(filteredList, function(sequence) {
      var filter = '';
      if (sequence.CourseAdmin === adminFilter) {
        filter = sequence.CourseAdmin;
      }
      return filter;
    });
  }

  self.numberOfShowingSequences(filteredList.length);
  return filteredList;
};

CourseOverviewList.prototype.sortSequences = function(header) {
  var self = this;

  if (self.activeSort === header) {
    header.asc = !header.asc;
  } else {
    self.activeSort = header;
  }
  var currentSorting = self.activeSort.asc ? self.compareAsc : self.compareDesc;

  var key = header.sortKey;
  switch (key) {
    case 'courseTitle':
      self.sequences.sort(currentSorting.bind('CourseTitle'));
      break;
    case 'date':
      self.sequences.sort(currentSorting.bind('FromDate'));
      break;
    case 'city':
      self.sequences.sort(currentSorting.bind('City'));
      break;
  }
};

CourseOverviewList.prototype.compareAsc = function(a, b) {
  if (this == 'courseTitle') {
    a = a.CourseTitle;
    b = b.CourseTitle;
  } else if (this == 'date') {
    a[this] = a[this] ? a[this] : '';
    b[this] = b[this] ? b[this] : '';
  } else if (this == 'city') {
    a = a.City;
    b = b.City;
  }

  return a[this] < b[this]
    ? -1
    : a[this] > b[this]
      ? 1
      : a[this] == b[this]
        ? 0
        : 0;
};

CourseOverviewList.prototype.compareDesc = function(b, a) {
  if (this == 'courseTitle') {
    a = a.CourseTitle;
    b = b.CourseTitle;
  } else if (this == 'date') {
    a[this] = a[this] ? a[this] : '';
    b[this] = b[this] ? b[this] : '';
  } else if (this == 'city') {
    a = a.City;
    b = b.City;
  }

  return a[this] < b[this]
    ? -1
    : a[this] > b[this]
      ? 1
      : a[this] == b[this]
        ? 0
        : 0;
};

module.exports = CourseOverviewList;
